<div class="slot-card-wrapper" [ngClass]="bgCardClass">
  <ng-container *ngIf="teamShiftDetail?.userTeams.length">
    <div class="team-member-section" *ngFor="let userTeam of displayedShiftDetails">
      <span class="text team-name mb-5">{{userTeam?.teamName ? userTeam?.teamName : (teamName?.userType === 'Mobile' ?
        '-' : 'Web User') }}</span>
      <div class="slot-wrapper">
        <span class="text slot" *ngFor="let schedule of userTeam?.slotTimeStr">
          <span class="text red-text"
            *ngIf="schedule.timeOff && activeShiftDetail?.leaveType && !activeShiftDetail?.fullDayOff">{{activeShiftDetail?.leaveType}}
            ({{ activeShiftDetail?.slotTimeStr}})</span>
          <span class="text red-text" *ngIf="schedule.timeOff && activeShiftDetail?.fullDayOff">{{activeShiftDetail?.leaveType}} (All
            Day)</span>
           <!-- <span *ngIf="!schedule?.timeOff" >{{schedule.slot}}</span>  -->
           <span *ngIf="!schedule?.timeOff" [ngStyle]="{'background-color': schedule?.scheduleSource === 'DUTY_ON_OFF' ? '#fcedce' : ''}">
            {{ schedule?.slot }}
          </span>
        </span>
      </div>
    </div>
  </ng-container>
  <div class="team-member-section ui-g-12" *ngIf="!teamShiftDetail.userTeams.length">
    <span class="text team-name" translate>label_unavailable</span>
  </div>
  <div class="button-wrapper ui-g">
    <div class="left-wrapper ui-g-12 ui-md-12 ui-lg-4">
      <span class="text team-name blue-text" (click)="op.toggle($event)"
       *ngIf="displayedShiftDetails.length > 0 && slotLength > 0" >{{slotLength}} more</span>
    </div>
    <!-- *ngIf="maxSlotLimitReached || shiftDetail.length > 1">{{shiftDetail.length ? shiftDetail.length : 1 }} more</span> -->
    <div class="right-wrapper ui-g-12 ui-md-12 ui-lg-8">
      <div class="shift-txt-break" tooltipStyleClass="notes-tooltip" *ngIf="activeShiftDetail?.notes" [escape]="false"
        pTooltip="<div class='tooltip-wrapper'><h5>Notes</h5> {{activeShiftDetail?.notes}} </div>" tooltipPosition="bottom" placeholder="Bottom">
        <div class="icon"><img src="/assets/images/temp/note.svg" alt="note icon" /></div>
      </div>
    <div class="icon" (click)="addSlot()" pTooltip="Add Time Off" tooltipPosition="top"
      tooltipStyleClass="custom-tooltip" *ngIf="!activeShiftDetail?.leaveType && (date.setHours(0,0,0,0) >= minDate.setHours(0,0,0,0)) && isPTOEnable">
        <img src="/assets/images/temp/add_time_off.svg" alt="add time off icon" />
      </div> 
     <!--  <div class="icon" (click)="addSlot()" pTooltip="Add Time Off" tooltipPosition="top"
      tooltipStyleClass="custom-tooltip" *ngIf="!activeShiftDetail?.leaveType && (date.setHours(0,0,0,0) >= minDate.setHours(0,0,0,0))">
        <img src="/assets/images/temp/add_time_off.svg" alt="add time off icon" />
      </div> -->
      <div class="icon" (click)="confirmCancelLeave()"
        *ngIf="teamShiftDetail?.memberStatusStr !== 'Unavailable' && activeShiftDetail?.leaveType && (date.setHours(0,0,0,0) >= minDate.setHours(0,0,0,0)) && isPTOEnable"><img
          src="/assets/images/temp/cancel_leave.svg" alt="cancel leave icon" /></div>
      <div class="icon" (click)="editSlot()" pTooltip="Manage shift" tooltipPosition="top"
      tooltipStyleClass="custom-tooltip" *ngIf="(!activeShiftDetail?.fullDayOff && (date.setHours(0,0,0,0) >= minDate.setHours(0,0,0,0)) && ((teamName?.userType === 'Mobile' && !organizationLevelDispatch && !teamLevelDutyFlag && !providerLevelDutyFlag)  || (teamName?.userType === 'Web')))">
      <img src="/assets/images/temp/edit_availability.svg"
          alt="edit availabilty icon" /></div>
    </div>
  </div>
</div>

<p-overlayPanel class="grid-overlay-panel" [showCloseIcon]="true" #op>
  <div class="body-wrapper" *ngFor="let userTeam of shiftDetail">
    <label class="text member-name">
      {{userTeam?.teamName ? userTeam?.teamName : (teamName?.userType === 'Mobile' ? '-' : 'Web User') }}
      <span class="colon-ml" *ngIf="userTeam?.slotTimeStr.length">:</span></label>

    <div class="slot-wrapper">
      <ng-container *ngFor="let shiftMemberSchedule of userTeam?.slotTimeStr; let isLast = last;">
        <span class="text red-text"
        *ngIf="shiftMemberSchedule.timeOff && activeShiftDetail?.leaveType && !activeShiftDetail?.fullDayOff">{{activeShiftDetail?.leaveType}}
        ({{ activeShiftDetail?.slotTimeStr}})</span>
      <span class="text red-text" *ngIf="shiftMemberSchedule.timeOff && activeShiftDetail?.fullDayOff">{{activeShiftDetail?.leaveType}} (All
        Day)</span>
        <span class="text" *ngIf="!shiftMemberSchedule?.timeOff"
        [ngStyle]="{'background-color': shiftMemberSchedule?.scheduleSource === 'DUTY_ON_OFF' ? '#fcedce' : ''}">{{shiftMemberSchedule.slot}}<span *ngIf="!isLast">,</span></span>
      </ng-container>
      <span class="text" *ngIf="!userTeam?.slotTimeStr.length">Shift Unavailable</span>
    </div>

  </div>
</p-overlayPanel>
